/*
 * AdminSideMenu Messages
 *
 * This contains all the text for the SideMenu component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  home: {
    id: 'app.components.SideMenu.home',
    defaultMessage: 'Home',
  },
  dashboard: {
    id: 'app.components.SideMenu.dashboard',
    defaultMessage: 'Dashboard',
  },
  users: {
    id: 'app.containers.Dashboard.users',
    defaultMessage: 'Users',
  },
  groups: {
    id: 'app.components.AdminGroups.groups',
    defaultMessage: 'Groups',
  },
  settings: {
    id: 'app.common.settings',
    defaultMessage: 'Settings',
  },
  close: {
    id: 'app.common.close',
    defaultMessage: 'Close',
  },
  paymentModule: {
    id: 'app.common.paymentModule',
    defaultMessage: 'Payment Module',
  },
});
